import * as React from "react";
import { useCallback, useMemo } from "react";
import { styled } from "@mui/material";
import { QualifiedFeatureFragment } from "fe-common/graphql";
import { FeatureWithName } from "fe-web-components/autocomplete";
import { SearchComponent, UserEnterSymptomsMode } from "./searchComponent";
import { useTranslate } from "../../hooks/useTranslate";
import { KahunCategories } from "shared";

//region [[ Styles ]]

const PanelSearchView = styled("div")({});

const Search = styled(SearchComponent)({
  maxWidth: "calc(100% - 13px)",
  "& .search-view": {
    border: "none",
    background: "white",
    borderRadius: "8px",
    height: "42px",
  },
  "& .ak-feature-selection-input": {
    padding: "5px 18px",
  },
  "& .list-container": {
    background: "white",
    border: "none",
    boxShadow: "0px 6px 18px 0px #0000001A",
    marginBottom: "30px",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
  },
  "& [rounded='true']": {
    opacity: "0.8",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  "& .enter-user-symptom-view": {
    marginTop: 0,
  },
  "& .enter-user-symptom-view .patient-MuiOutlinedInput-root.patient-Mui-focused .MuiOutlinedInput-notchedOutline, & .enter-user-symptom-view .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PanelSearchProps {
  onSelected?: (qf: QualifiedFeatureFragment) => void;
  filteredFeatures?: QualifiedFeatureFragment[];
  isFirst?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
export const CURATED_FEATURES_PANEL_ID =
  "FE.19e40328-ce3b-469a-9320-4b6967a50558";

/* Create a settings object to avoid re-creating it on each render */
const panelSearchOptions = {
  panelIds: null,
  patientFacing: true,
  categories: [KahunCategories.DISORDERS],
};
/***
 * Searche components that search within the curated featrues list
 * @param props
 * @constructor
 */
export const PatientPanelSearch = ({
  onSelected,
  filteredFeatures,
  ...props
}: PanelSearchProps) => {
  const { translate } = useTranslate();

  const handleSearchSelected = useCallback(
    (event, featureWithName: FeatureWithName) => {
      if (featureWithName?.value) {
        onSelected(featureWithName.value);
      }
    },
    [onSelected],
  );

  const filteredIds = useMemo(() => filteredFeatures.map((qf) => qf.id), [
    filteredFeatures,
  ]);

  return (
    <PanelSearchView>
      <Search
        onChange={handleSearchSelected}
        placeholder={translate(
          props.isFirst
            ? "PANEL_FIRST_SEARCH_PLACEHOLDER"
            : "PANEL_SEARCH_PLACEHOLDER",
        )}
        searchOptions={panelSearchOptions}
        filteredIds={filteredIds}
        autoFocus={false}
        noIcon
        userEnterSymptom={UserEnterSymptomsMode.FREE_TEXT}
        enterSymptomTextOverride={{
          titleText: "ENTER_DISORDER_DESCRIPTION",
          cantFindText: "CANT_FIND_A_DISORDER",
          placeholderText: "ENTER_YOUR_DISORDER",
          thankYouText: "THANKS_ENTER_SYMPTOM",
        }}
      />
    </PanelSearchView>
  );
};
